// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"divisions__gradient-bg5__HM5CH","confirmPopup":"divisions__confirmPopup__zioNJ","title":"divisions__title__zplaF","description":"divisions__description__KuEXk"};